import flatten from "lodash/flatten";
import values from "lodash/values";
import groupBy from "lodash/groupBy";

import lightstick from "../../assets/images/lightstick.jpeg";
import taeyong from "../../assets/images/taeyong.jpg";
import taeyong1 from "../../assets/images/taeyong-1.jpeg";
import taeyong2 from "../../assets/images/taeyong-2.jpeg";
import taeyong3 from "../../assets/images/taeyong-3.jpg";
import taeyong4 from "../../assets/images/taeyong-4.jpeg";
import taeyong5 from "../../assets/images/taeyong-5.jpeg";
import taeyong6 from "../../assets/images/taeyong-6.jpg";
import taeyong7 from "../../assets/images/taeyong-7.jpeg";
import taeyong8 from "../../assets/images/taeyong-8.jpg";
import taeyong9 from "../../assets/images/taeyong-9.jpeg";
import taeyong10 from "../../assets/images/taeyong-10.jpg";

const photocard = {};

const taeyongImages = {
  taeyong,
  "taeyong-1": taeyong1,
  "taeyong-2": taeyong2,
  "taeyong-3": taeyong3,
  "taeyong-4": taeyong4,
  "taeyong-5": taeyong5,
  "taeyong-6": taeyong6,
  "taeyong-7": taeyong7,
  "taeyong-8": taeyong8,
  "taeyong-9": taeyong9,
  "taeyong-10": taeyong10,
};

const photocardImageContext = require.context("../../assets/photocards", false, /^(?!.*taeyong-).*\.(jpe?g|png)$/);
const photocardImages = photocardImageContext.keys().reduce((images, path) => {
  const filename = path.replace("./", "");
  const key = filename.replace(/\.[^.]+$/, "");
  images[key] = photocardImageContext(path);
  return images;
}, taeyongImages);

export const getPhotocardImage = (pc) => {
  if (!pc) {
    return lightstick;
  }

  if (photocardImages[pc.key]) {
    return photocardImages[pc.key];
  }

  const memberKey = pc.member && pc.member.toLowerCase();
  if (photocardImages[memberKey]) {
    return photocardImages[memberKey];
  }

  if (pc.path && !pc.path.includes("firebasestorage.googleapis.com")) {
    return pc.path;
  }

  return lightstick;
};
photocard.getPhotocardImage = getPhotocardImage;

// Organize photocards by name, group
photocard.photocards = [
  {
    member: "Chenle",
    key: "chenle-1",
    units: ["NCT", "Dream"],
  },
  {
    member: "Chenle",
    key: "chenle-2",
    units: ["NCT", "Dream"],
  },
  {
    member: "Chenle",
    key: "chenle-3",
    units: ["NCT", "Dream"],
  },
  {
    member: "Chenle",
    key: "chenle-4",
    units: ["NCT", "Dream"],
  },
  {
    member: "Chenle",
    key: "chenle-5",
    units: ["NCT", "Dream"],
  },
  {
    member: "Chenle",
    key: "chenle-6",
    units: ["NCT", "Dream"],
  },
  {
    member: "Chenle",
    key: "chenle-7",
    units: ["NCT", "Dream"],
  },
  {
    member: "Chenle",
    key: "chenle-8",
    units: ["NCT", "Dream"],
  },
  {
    member: "Chenle",
    key: "chenle-9",
    units: ["NCT", "Dream"],
  },
  {
    member: "Chenle",
    key: "chenle-10",
    units: ["NCT", "Dream"],
  },
  {
    member: "Doyoung",
    key: "doyoung-1",
    units: ["NCT", "127"],
  },
  {
    member: "Doyoung",
    key: "doyoung-2",
    units: ["NCT", "127"],
  },
  {
    member: "Doyoung",
    key: "doyoung-3",
    units: ["NCT", "127"],
  },
  {
    member: "Doyoung",
    key: "doyoung-4",
    units: ["NCT", "127"],
  },
  {
    member: "Doyoung",
    key: "doyoung-5",
    units: ["NCT", "127"],
  },
  {
    member: "Doyoung",
    key: "doyoung-6",
    units: ["NCT", "127"],
  },
  {
    member: "Doyoung",
    key: "doyoung-7",
    units: ["NCT", "127"],
  },
  {
    member: "Doyoung",
    key: "doyoung-8",
    units: ["NCT", "127"],
  },
  {
    member: "Doyoung",
    key: "doyoung-9",
    units: ["NCT", "127"],
  },
  {
    member: "Doyoung",
    key: "doyoung-10",
    units: ["NCT", "127"],
  },
  {
    member: "Haechan",
    key: "haechan-1",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Haechan",
    key: "haechan-2",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Haechan",
    key: "haechan-3",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Haechan",
    key: "haechan-4",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Haechan",
    key: "haechan-5",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Haechan",
    key: "haechan-6",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Haechan",
    key: "haechan-7",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Haechan",
    key: "haechan-8",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Haechan",
    key: "haechan-9",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Haechan",
    key: "haechan-10",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Hendery",
    key: "hendery-1",
    units: ["NCT", "WayV"],
  },
  {
    member: "Hendery",
    key: "hendery-2",
    units: ["NCT", "WayV"],
  },
  {
    member: "Hendery",
    key: "hendery-3",
    units: ["NCT", "WayV"],
  },
  {
    member: "Hendery",
    key: "hendery-4",
    units: ["NCT", "WayV"],
  },
  {
    member: "Hendery",
    key: "hendery-5",
    units: ["NCT", "WayV"],
  },
  {
    member: "Hendery",
    key: "hendery-6",
    units: ["NCT", "WayV"],
  },
  {
    member: "Hendery",
    key: "hendery-7",
    units: ["NCT", "WayV"],
  },
  {
    member: "Hendery",
    key: "hendery-8",
    units: ["NCT", "WayV"],
  },
  {
    member: "Hendery",
    key: "hendery-9",
    units: ["NCT", "WayV"],
  },
  {
    member: "Hendery",
    key: "hendery-10",
    units: ["NCT", "WayV"],
  },
  {
    member: "Jaehyun",
    key: "jaehyun-1",
    units: ["NCT", "127"],
  },
  {
    member: "Jaehyun",
    key: "jaehyun-2",
    units: ["NCT", "127"],
  },
  {
    member: "Jaehyun",
    key: "jaehyun-3",
    units: ["NCT", "127"],
  },
  {
    member: "Jaehyun",
    key: "jaehyun-4",
    units: ["NCT", "127"],
  },
  {
    member: "Jaehyun",
    key: "jaehyun-5",
    units: ["NCT", "127"],
  },
  {
    member: "Jaehyun",
    key: "jaehyun-6",
    units: ["NCT", "127"],
  },
  {
    member: "Jaehyun",
    key: "jaehyun-7",
    units: ["NCT", "127"],
  },
  {
    member: "Jaehyun",
    key: "jaehyun-8",
    units: ["NCT", "127"],
  },
  {
    member: "Jaehyun",
    key: "jaehyun-9",
    units: ["NCT", "127"],
  },
  {
    member: "Jaehyun",
    key: "jaehyun-10",
    units: ["NCT", "127"],
  },
  {
    member: "Jaemin",
    key: "jaemin-1",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jaemin",
    key: "jaemin-2",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jaemin",
    key: "jaemin-3",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jaemin",
    key: "jaemin-4",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jaemin",
    key: "jaemin-5",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jaemin",
    key: "jaemin-6",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jaemin",
    key: "jaemin-7",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jaemin",
    key: "jaemin-8",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jaemin",
    key: "jaemin-9",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jaemin",
    key: "jaemin-10",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jeno",
    key: "jeno-1",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jeno",
    key: "jeno-2",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jeno",
    key: "jeno-3",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jeno",
    key: "jeno-4",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jeno",
    key: "jeno-5",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jeno",
    key: "jeno-6",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jeno",
    key: "jeno-7",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jeno",
    key: "jeno-8",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jeno",
    key: "jeno-9",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jeno",
    key: "jeno-10",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jisung",
    key: "jisung-1",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jisung",
    key: "jisung-2",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jisung",
    key: "jisung-3",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jisung",
    key: "jisung-4",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jisung",
    key: "jisung-5",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jisung",
    key: "jisung-6",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jisung",
    key: "jisung-7",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jisung",
    key: "jisung-8",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jisung",
    key: "jisung-9",
    units: ["NCT", "Dream"],
  },
  {
    member: "Jisung",
    key: "jisung-10",
    units: ["NCT", "Dream"],
  },
  {
    member: "Johnny",
    key: "johnny-1",
    units: ["NCT", "127"],
  },
  {
    member: "Johnny",
    key: "johnny-2",
    units: ["NCT", "127"],
  },
  {
    member: "Johnny",
    key: "johnny-3",
    units: ["NCT", "127"],
  },
  {
    member: "Johnny",
    key: "johnny-4",
    units: ["NCT", "127"],
  },
  {
    member: "Johnny",
    key: "johnny-5",
    units: ["NCT", "127"],
  },
  {
    member: "Johnny",
    key: "johnny-6",
    units: ["NCT", "127"],
  },
  {
    member: "Johnny",
    key: "johnny-7",
    units: ["NCT", "127"],
  },
  {
    member: "Johnny",
    key: "johnny-8",
    units: ["NCT", "127"],
  },
  {
    member: "Johnny",
    key: "johnny-9",
    units: ["NCT", "127"],
  },
  {
    member: "Johnny",
    key: "johnny-10",
    units: ["NCT", "127"],
  },
  {
    member: "Jungwoo",
    key: "jungwoo-1",
    units: ["NCT", "127"],
  },
  {
    member: "Jungwoo",
    key: "jungwoo-2",
    units: ["NCT", "127"],
  },
  {
    member: "Jungwoo",
    key: "jungwoo-3",
    units: ["NCT", "127"],
  },
  {
    member: "Jungwoo",
    key: "jungwoo-4",
    units: ["NCT", "127"],
  },
  {
    member: "Jungwoo",
    key: "jungwoo-5",
    units: ["NCT", "127"],
  },
  {
    member: "Jungwoo",
    key: "jungwoo-6",
    units: ["NCT", "127"],
  },
  {
    member: "Jungwoo",
    key: "jungwoo-7",
    units: ["NCT", "127"],
  },
  {
    member: "Jungwoo",
    key: "jungwoo-8",
    units: ["NCT", "127"],
  },
  {
    member: "Jungwoo",
    key: "jungwoo-9",
    units: ["NCT", "127"],
  },
  {
    member: "Jungwoo",
    key: "jungwoo-10",
    units: ["NCT", "127"],
  },
  {
    member: "Kun",
    key: "kun-1",
    units: ["NCT", "WayV"],
  },
  {
    member: "Kun",
    key: "kun-2",
    units: ["NCT", "WayV"],
  },
  {
    member: "Kun",
    key: "kun-3",
    units: ["NCT", "WayV"],
  },
  {
    member: "Kun",
    key: "kun-4",
    units: ["NCT", "WayV"],
  },
  {
    member: "Kun",
    key: "kun-5",
    units: ["NCT", "WayV"],
  },
  {
    member: "Kun",
    key: "kun-6",
    units: ["NCT", "WayV"],
  },
  {
    member: "Kun",
    key: "kun-7",
    units: ["NCT", "WayV"],
  },
  {
    member: "Kun",
    key: "kun-8",
    units: ["NCT", "WayV"],
  },
  {
    member: "Kun",
    key: "kun-9",
    units: ["NCT", "WayV"],
  },
  {
    member: "Kun",
    key: "kun-10",
    units: ["NCT", "WayV"],
  },
  {
    member: "Lucas",
    key: "lucas-1",
    units: ["NCT", "WayV"],
  },
  {
    member: "Lucas",
    key: "lucas-2",
    units: ["NCT", "WayV"],
  },
  {
    member: "Lucas",
    key: "lucas-3",
    units: ["NCT", "WayV"],
  },
  {
    member: "Lucas",
    key: "lucas-4",
    units: ["NCT", "WayV"],
  },
  {
    member: "Lucas",
    key: "lucas-5",
    units: ["NCT", "WayV"],
  },
  {
    member: "Lucas",
    key: "lucas-6",
    units: ["NCT", "WayV"],
  },
  {
    member: "Lucas",
    key: "lucas-7",
    units: ["NCT", "WayV"],
  },
  {
    member: "Lucas",
    key: "lucas-8",
    units: ["NCT", "WayV"],
  },
  {
    member: "Lucas",
    key: "lucas-9",
    units: ["NCT", "WayV"],
  },
  {
    member: "Lucas",
    key: "lucas-10",
    units: ["NCT", "WayV"],
  },
  {
    member: "Mark",
    key: "mark-1",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Mark",
    key: "mark-2",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Mark",
    key: "mark-3",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Mark",
    key: "mark-4",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Mark",
    key: "mark-5",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Mark",
    key: "mark-6",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Mark",
    key: "mark-7",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Mark",
    key: "mark-8",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Mark",
    key: "mark-9",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Mark",
    key: "mark-10",
    units: ["NCT", "127", "Dream"],
  },
  {
    member: "Renjun",
    key: "renjun-1",
    units: ["NCT", "Dream"],
  },
  {
    member: "Renjun",
    key: "renjun-2",
    units: ["NCT", "Dream"],
  },
  {
    member: "Renjun",
    key: "renjun-3",
    units: ["NCT", "Dream"],
  },
  {
    member: "Renjun",
    key: "renjun-4",
    units: ["NCT", "Dream"],
  },
  {
    member: "Renjun",
    key: "renjun-5",
    units: ["NCT", "Dream"],
  },
  {
    member: "Renjun",
    key: "renjun-6",
    units: ["NCT", "Dream"],
  },
  {
    member: "Renjun",
    key: "renjun-7",
    units: ["NCT", "Dream"],
  },
  {
    member: "Renjun",
    key: "renjun-8",
    units: ["NCT", "Dream"],
  },
  {
    member: "Renjun",
    key: "renjun-9",
    units: ["NCT", "Dream"],
  },
  {
    member: "Renjun",
    key: "renjun-10",
    units: ["NCT", "Dream"],
  },
  {
    member: "Taeil",
    key: "taeil-1",
    units: ["NCT", "127"],
  },
  {
    member: "Taeil",
    key: "taeil-2",
    units: ["NCT", "127"],
  },
  {
    member: "Taeil",
    key: "taeil-3",
    units: ["NCT", "127"],
  },
  {
    member: "Taeil",
    key: "taeil-4",
    units: ["NCT", "127"],
  },
  {
    member: "Taeil",
    key: "taeil-5",
    units: ["NCT", "127"],
  },
  {
    member: "Taeil",
    key: "taeil-6",
    units: ["NCT", "127"],
  },
  {
    member: "Taeil",
    key: "taeil-7",
    units: ["NCT", "127"],
  },
  {
    member: "Taeil",
    key: "taeil-8",
    units: ["NCT", "127"],
  },
  {
    member: "Taeil",
    key: "taeil-9",
    units: ["NCT", "127"],
  },
  {
    member: "Taeil",
    key: "taeil-10",
    units: ["NCT", "127"],
  },
  {
    member: "Taeyong",
    key: "taeyong-1",
    units: ["NCT", "127"],
  },
  {
    member: "Taeyong",
    key: "taeyong-2",
    units: ["NCT", "127"],
  },
  {
    member: "Taeyong",
    key: "taeyong-3",
    units: ["NCT", "127"],
  },
  {
    member: "Taeyong",
    key: "taeyong-4",
    units: ["NCT", "127"],
  },
  {
    member: "Taeyong",
    key: "taeyong-5",
    units: ["NCT", "127"],
  },
  {
    member: "Taeyong",
    key: "taeyong-6",
    units: ["NCT", "127"],
  },
  {
    member: "Taeyong",
    key: "taeyong-7",
    units: ["NCT", "127"],
  },
  {
    member: "Taeyong",
    key: "taeyong-8",
    units: ["NCT", "127"],
  },
  {
    member: "Taeyong",
    key: "taeyong-9",
    units: ["NCT", "127"],
  },
  {
    member: "Taeyong",
    key: "taeyong-10",
    units: ["NCT", "127"],
  },
  {
    member: "Ten",
    key: "ten-1",
    units: ["NCT", "WayV"],
  },
  {
    member: "Ten",
    key: "ten-2",
    units: ["NCT", "WayV"],
  },
  {
    member: "Ten",
    key: "ten-3",
    units: ["NCT", "WayV"],
  },
  {
    member: "Ten",
    key: "ten-4",
    units: ["NCT", "WayV"],
  },
  {
    member: "Ten",
    key: "ten-5",
    units: ["NCT", "WayV"],
  },
  {
    member: "Ten",
    key: "ten-6",
    units: ["NCT", "WayV"],
  },
  {
    member: "Ten",
    key: "ten-7",
    units: ["NCT", "WayV"],
  },
  {
    member: "Ten",
    key: "ten-8",
    units: ["NCT", "WayV"],
  },
  {
    member: "Ten",
    key: "ten-9",
    units: ["NCT", "WayV"],
  },
  {
    member: "Ten",
    key: "ten-10",
    units: ["NCT", "WayV"],
  },
  {
    member: "Winwin",
    key: "winwin-1",
    units: ["NCT", "127", "WayV"],
  },
  {
    member: "Winwin",
    key: "winwin-2",
    units: ["NCT", "127", "WayV"],
  },
  {
    member: "Winwin",
    key: "winwin-3",
    units: ["NCT", "127", "WayV"],
  },
  {
    member: "Winwin",
    key: "winwin-4",
    units: ["NCT", "127", "WayV"],
  },
  {
    member: "Winwin",
    key: "winwin-5",
    units: ["NCT", "127", "WayV"],
  },
  {
    member: "Winwin",
    key: "winwin-6",
    units: ["NCT", "127", "WayV"],
  },
  {
    member: "Winwin",
    key: "winwin-7",
    units: ["NCT", "127", "WayV"],
  },
  {
    member: "Winwin",
    key: "winwin-8",
    units: ["NCT", "127", "WayV"],
  },
  {
    member: "Winwin",
    key: "winwin-9",
    units: ["NCT", "127", "WayV"],
  },
  {
    member: "Winwin",
    key: "winwin-10",
    units: ["NCT", "127", "WayV"],
  },
  {
    member: "Xiaojun",
    key: "xiaojun-1",
    units: ["NCT", "WayV"],
  },
  {
    member: "Xiaojun",
    key: "xiaojun-2",
    units: ["NCT", "WayV"],
  },
  {
    member: "Xiaojun",
    key: "xiaojun-3",
    units: ["NCT", "WayV"],
  },
  {
    member: "Xiaojun",
    key: "xiaojun-4",
    units: ["NCT", "WayV"],
  },
  {
    member: "Xiaojun",
    key: "xiaojun-5",
    units: ["NCT", "WayV"],
  },
  {
    member: "Xiaojun",
    key: "xiaojun-6",
    units: ["NCT", "WayV"],
  },
  {
    member: "Xiaojun",
    key: "xiaojun-7",
    units: ["NCT", "WayV"],
  },
  {
    member: "Xiaojun",
    key: "xiaojun-8",
    units: ["NCT", "WayV"],
  },
  {
    member: "Xiaojun",
    key: "xiaojun-9",
    units: ["NCT", "WayV"],
  },
  {
    member: "Xiaojun",
    key: "xiaojun-10",
    units: ["NCT", "WayV"],
  },
  {
    member: "Yangyang",
    key: "yangyang-1",
    units: ["NCT", "WayV"],
  },
  {
    member: "Yangyang",
    key: "yangyang-2",
    units: ["NCT", "WayV"],
  },
  {
    member: "Yangyang",
    key: "yangyang-3",
    units: ["NCT", "WayV"],
  },
  {
    member: "Yangyang",
    key: "yangyang-4",
    units: ["NCT", "WayV"],
  },
  {
    member: "Yangyang",
    key: "yangyang-5",
    units: ["NCT", "WayV"],
  },
  {
    member: "Yangyang",
    key: "yangyang-6",
    units: ["NCT", "WayV"],
  },
  {
    member: "Yangyang",
    key: "yangyang-7",
    units: ["NCT", "WayV"],
  },
  {
    member: "Yangyang",
    key: "yangyang-8",
    units: ["NCT", "WayV"],
  },
  {
    member: "Yangyang",
    key: "yangyang-9",
    units: ["NCT", "WayV"],
  },
  {
    member: "Yangyang",
    key: "yangyang-10",
    units: ["NCT", "WayV"],
  },
  {
    member: "Yuta",
    key: "yuta-1",
    units: ["NCT", "127"],
  },
  {
    member: "Yuta",
    key: "yuta-2",
    units: ["NCT", "127"],
  },
  {
    member: "Yuta",
    key: "yuta-3",
    units: ["NCT", "127"],
  },
  {
    member: "Yuta",
    key: "yuta-4",
    units: ["NCT", "127"],
  },
  {
    member: "Yuta",
    key: "yuta-5",
    units: ["NCT", "127"],
  },
  {
    member: "Yuta",
    key: "yuta-6",
    units: ["NCT", "127"],
  },
  {
    member: "Yuta",
    key: "yuta-7",
    units: ["NCT", "127"],
  },
  {
    member: "Yuta",
    key: "yuta-8",
    units: ["NCT", "127"],
  },
  {
    member: "Yuta",
    key: "yuta-9",
    units: ["NCT", "127"],
  },
  {
    member: "Yuta",
    key: "yuta-10",
    units: ["NCT", "127"],
  },
  {
    member: "Sungchan",
    key: "sungchan-1",
    units: ["NCT"],
  },
  {
    member: "Shotaro",
    key: "shotaro-1",
    units: ["NCT"],
  },
];

export const calcStats = (photocardList) => {
  const result = {};
  const allUnits = flatten(photocardList.map((pc) => pc.units));
  values(groupBy(allUnits)).forEach((d) => (result[d[0]] = d.length));
  return result;
};
photocard.calcStats = calcStats;

export const stats = photocard.calcStats(photocard.photocards);
photocard.stats = stats;

export default photocard;
